/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

var currentSummaryIndex = 0;
// Summary indexes
// Monitor
var retryPageIndex = 0;
var diagnosticPageIndex = 0;
var faultPageIndex = 0;
let errorFramaPageIndex = 0;
var missingPageIndex = 0;

// Meio Fisico
var attentionSignalPageIndex = 0;
var badSignalPageIndex = 0;
var capacitiveEffectPageIndex = 0;
var noisePageIndex = 0;

// Disclaimer
var disclaimerPageIndex = 0;

export class TsExpertReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      // Protocol
      firstRetryPage: -1,
      firstDiagnosticPage: -1,
      firstFaultPage: -1,
      firstErrorFramePage: -1,
      firstMissingPage: -1,
      // Meio Fisico
      firstAttentionSignalPage: -1,
      firstBadSignalPage: -1,
      firstCapacitiveEffectPage: -1,
      firstNoisePage: -1,
      // Summary numbering control
      // Protocol
      isFirstRetryPage: true,
      isFirstDiagnosticPage: true,
      isFirstFaultPage: true,
      isFirstErrorFramePagePage: true,
      isFirstMissingPage: true,
      // Meio Fisico
      isAttentionSignalPage: true,
      isFirstBadSignalPage: true,
      isFirstCapacitiveEffectPage: true,
      isFirstNoisePage: true,
      // The report itself
      doc: ""
    };

  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  formatTime = (problem) => {
    if (problem.ntp !== null && problem.ntp === true) {
      let parsedMillis = Date.parse(problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problem.time !== undefined && problem.time !== null) {
      const eventTimeInMillis = problem.time * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  formatTimeUpdate = (problem) => {
    if (problem.ntp !== null && problem.ntp === true) {
      let parsedMillis = Date.parse(problem.timeUpdate);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problem.timeUpdate !== undefined && problem.timeUpdate !== null) {
      const eventTimeInMillis = problem.timeUpdate * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  formatTime2 = (problemTime, ntp) => {
    if (ntp !== null && ntp === true) {
      let parsedMillis = Date.parse(problemTime);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (problemTime !== undefined && problemTime !== null) {
      const eventTimeInMillis = problemTime * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  /*
    The measurement time that is retrieved from the database comes as a string.
    We had a problem that the time that was being retrieved was not correct. 
    The workarround we found for this was to remove the last two characters of 
    the string and it miraculously it was in the format we nedded 
  */
  formatUptimeStringToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      let uptimeSubstring = uptimeInSeconds.substring(0, uptimeInSeconds.length - 2);
      let uptimeSubstringNumber = parseInt(uptimeSubstring);
      const uptimeInMillis = uptimeSubstringNumber * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + " ano" + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + " mês");
      }
      else {
        out.push(md + " meses");
      }
    }
    if (dd > 0) out.push(dd + " dia" + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + "h");
    if (nd > 0) out.push(nd + "m");
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  parseFloatTo2DecimalPlaces = (floatInput) => {
    // If the floatInput is not 'None' return the number trimmed to 2 decimal places
    if (floatInput !== Constants.NONE) {
      return parseFloat(floatInput).toFixed(2);
    }
    else {
      return floatInput;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.TS_EXPERT_REPORT_EXPORT_NAME_PROTOCOL}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateNow()}, Página ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "retries" && this.state.isFirstRetryPage) {
      this.setState({
        firstRetryPage: pageNumber + 1,
        isFirstRetryPage: false
      });
    }
    else if (reportPart === "diagnostic" && this.state.isFirstDiagnosticPage) {
      this.setState({
        firstDiagnosticPage: pageNumber + 1,
        isFirstDiagnosticPage: false
      });
    }
    else if (reportPart === "fault" && this.state.isFirstFaultPage) {
      this.setState({
        firstFaultPage: pageNumber + 1,
        isFirstFaultPage: false
      });
    }
    else if (reportPart === "errorFrame" && this.state.isFirstErrorFramePagePage) {
      this.setState({
        firstErrorFramePage: pageNumber + 1,
        isFirstErrorFramePagePage: false
      });
    }
    else if (reportPart === "missing" && this.state.isFirstMissingPage) {
      this.setState({
        firstMissingPage: pageNumber + 1,
        isFirstMissingPage: false
      });
    }
    else if (reportPart === "attentionSignal" && this.state.isAttentionSignalPage) {
      this.setState({
        firstAttentionSignalPage: pageNumber + 1,
        isAttentionSignalPage: false
      });
    }
    else if (reportPart === "badSignal" && this.state.isFirstBadSignalPage) {
      this.setState({
        firstBadSignalPage: pageNumber + 1,
        isFirstBadSignalPage: false
      });
    }
    else if (reportPart === "capacitiveEffect" && this.state.isFirstCapacitiveEffectPage) {
      this.setState({
        firstCapacitiveEffectPage: pageNumber + 1,
        isFirstCapacitiveEffectPage: false
      });
    }
    else if (reportPart === "noise" && this.state.isFirstNoisePage) {
      this.setState({
        firstNoisePage: pageNumber + 1,
        isFirstNoisePage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.TS_EXPERT_REPORT_EXPORT_NAME_PROTOCOL}>
      {this.createIntroPage()}
      {this.createDataInfoPage()}
      {this.createSummaryPage()}
      {/* Protocol */}
      {this.createRetriesPages()}
      {this.createDiagnosticsPages()}
      {this.createFaultsPages()}
      {this.createErrorFramePages()}
      {this.createMissingPages()}
      {/* Meio Fisico */}
      {this.createAttentionSignalPages()}
      {this.createBadSignalPages()}
      {this.createCapacitiveEffectPages()}
      {this.createNoisePages()}
      {/* Disclaimer */}
      {this.createDisclaimerPage()}
    </Document>;
    return doc;
  }

  createIntroPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "28vh" }} />

        <View style={reusableStyles.mainTitleUpperLine} />

        <Text style={reusableStyles.mainTitle}>
          {Strings.TS_EXPERT + ":"}
        </Text>

        <Text style={reusableStyles.mainTitle2}>
          {Strings.ACTIONS}
        </Text>

        <View style={reusableStyles.mainTitleBottomLine} />

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Data Information ------------------------
  createDataInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.DATA_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.MONITORING_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.TAG_NAME_DN}{this.props.tag} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_VERSION_DN}{Constants.TS_MONITOR_VERSION} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_INIT_DN}{UtilsInstance.getMonitorInitTime(this.props.uptime, UtilsInstance)} </Text>
        <Text style={reusableStyles.normalText}>{Strings.GENERATING_TIME_DN}{this.getDateTimeNow()} </Text>
        <Text style={reusableStyles.lastInfoText}>{Strings.DURATION_SINCE_MON_BEGIN}{UtilsInstance.formatToRelativeTime2(this.props.uptime, UtilsInstance)} </Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.ETHERNET_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.IP_DN}{this.props.configData.addr} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DN}{this.props.configData.netmask} </Text>
        <Text style={reusableStyles.lastInfoText}>{Strings.GATEWAY_DN}{this.props.configData.gateway} </Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.WLAN_INFO}</Text>
        <View style={reusableStyles.subHeaderInnerLine} />

        <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME_DN}{this.props.wifiConfigData.wifiName}</Text>
        <Text style={reusableStyles.normalText}>{Strings.IP_DN}{this.props.wifiConfigData.wifiAddr}</Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DN}{this.props.wifiConfigData.wifiNetmask}</Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DN}{this.props.wifiConfigData.wifiGateway}</Text>

        {this.getPageFooter()}

      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        {/* Protocol */}
        {this.getSummaryItem(Constants.RETRIES_ERROR_TYPE)}
        {this.getSummaryItem(Constants.DIAGNOSTIC_ERROR_TYPE)}
        {this.getSummaryItem(Constants.FAULT_ERROR_TYPE)}
        {this.getSummaryItem(Constants.ERROR_FRAME_TYPE)}
        {this.getSummaryItem(Constants.MISSING_ERROR_TYPE)}
        {/* Meio Fisico */}
        {this.getSummaryItem(Constants.ATTENTION_SIGNAL_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.BAD_SIGNAL_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE)}
        {this.getSummaryItem(Constants.NOISE_PROBLEM_TYPE)}
        {/* Disclaimer */}
        {this.getSummaryItem("disclaimer")}

        {this.getPageFooter()}

      </Page>
    );
  }

  getSummaryItem = (type) => {
    // Protocol
    if (type === Constants.RETRIES_ERROR_TYPE && this.props.retries.length > 0) {
      currentSummaryIndex++;
      retryPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {retryPageIndex}. {Strings.DEVICE_UPDATE_WITH_RETRIES} {Strings.DEVICE_WITH_RETRIES_DOTS} {this.state.firstRetryPage}
        </Text>
      );
    }
    else if (type === Constants.DIAGNOSTIC_ERROR_TYPE && this.props.diagnostic.length > 0) {
      currentSummaryIndex++;
      diagnosticPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {diagnosticPageIndex}. {Strings.DEVICE_UPDATE_WITH_DIAGNOSTIC} {Strings.DEVICE_WITH_DIAGNOSTIC_DOTS} {this.state.firstDiagnosticPage}
        </Text>
      );
    }
    else if (type === Constants.FAULT_ERROR_TYPE && this.props.fault.length > 0) {
      currentSummaryIndex++;
      faultPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {faultPageIndex}. {Strings.DEVICE_UPDATE_WITH_FAULT} {Strings.DEVICE_WITH_FAULT_DOTS} {this.state.firstFaultPage}
        </Text>
      );
    }
    else if (type === Constants.ERROR_FRAME_TYPE && this.props.errorFrame.length > 0) {
      currentSummaryIndex++;
      errorFramaPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {errorFramaPageIndex}. {Strings.DEVICE_WITH_UPDATE_ERROR_FRAME} {Strings.DEVICE_WITH_ERROR_FRAME_DOTS} {this.state.firstErrorFramePage}
        </Text>
      );
    }
    else if (type === Constants.MISSING_ERROR_TYPE && this.props.missing.length > 0) {
      currentSummaryIndex++;
      missingPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {missingPageIndex}. {Strings.DEVICE_MISSING_UPDATE} {Strings.DEVICE_MISSING_DOTS} {this.state.firstMissingPage}
        </Text>
      );
    }
    // Meio Fisico
    else if (type === Constants.ATTENTION_SIGNAL_PROBLEM_TYPE && this.props.attentionSignal.length > 0) {
      currentSummaryIndex++;
      attentionSignalPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {attentionSignalPageIndex}. {Strings.ATTENTION_SIGNAL} {Strings.ATTENTION_SIGNAL_DOTS} {this.state.firstAttentionSignalPage}
        </Text>
      );
    }
    else if (type === Constants.BAD_SIGNAL_PROBLEM_TYPE && this.props.badSignal.length > 0) {
      currentSummaryIndex++;
      badSignalPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {badSignalPageIndex}. {Strings.BAD_SIGNAL} {Strings.BAD_SIGNAL_DOTS} {this.state.firstBadSignalPage}
        </Text>
      );
    }
    else if (type === Constants.CAPACITIVE_EFFECT_PROBLEM_TYPE && this.props.capacitiveEffect.length > 0) {
      currentSummaryIndex++;
      capacitiveEffectPageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {capacitiveEffectPageIndex}. {Strings.CAPACITIVE_EFFECT} {Strings.CAPACITIVE_EFFECT_DOTS} {this.state.firstCapacitiveEffectPage}
        </Text>
      );
    }
    else if (type === Constants.NOISE_PROBLEM_TYPE && this.props.noise.length > 0) {
      currentSummaryIndex++;
      noisePageIndex = currentSummaryIndex;
      return (
        <Text style={reusableStyles.summaryText} fixed>
          {noisePageIndex}. {Strings.NOISE} {Strings.NOISE_DOTS} {this.state.firstNoisePage}
        </Text>
      );
    }
    // Disclaimer
    else if (type === "disclaimer") {
      currentSummaryIndex++;
      disclaimerPageIndex = currentSummaryIndex;
      if (disclaimerPageIndex >= 10) {
        return (
          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_EXPERT_DOTS_1} ${totalPages}`
          )} fixed />
        );
      }
      else {
        return (
          <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
            `${disclaimerPageIndex}. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_EXPERT_DOTS_2_PROTOCOL} ${totalPages}`
          )} fixed />
        );
      }

    }
  }

  resetSummaryIndexes = () => {
    currentSummaryIndex = 0;
    // Protocol
    retryPageIndex = 0;
    diagnosticPageIndex = 0;
    faultPageIndex = 0;
    errorFramaPageIndex = 0;
    missingPageIndex = 0;
    // Meio Fisico
    attentionSignalPageIndex = 0;
    badSignalPageIndex = 0;
    capacitiveEffectPageIndex = 0;
    noisePageIndex = 0;

    // Disclaimer
    disclaimerPageIndex = 0;
  }

  // ----------------- MISSING -----------------
  createMissingPages = () => {
    if (this.props.missing.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={missingStyles.page}>

          {this.getPageHeader()}

          <Text style={missingStyles.pageTitle} fixed>{missingPageIndex}. - {Strings.DEVICE_MISSING_UPDATE}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.MISSING_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.MISSING_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.MISSING_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.MISSING_SUGGESTION_4}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={[retryStyles.table, { alignItems: 'center'}]}>
            {this.createMissingTableHeader()}
            {this.createMissingTable()}
          </View>

          {this.getPageFooter("missing")}

        </Page>
      );
    }
  }

  createMissingTableHeader = () => {
    return (
      <View style={missingStyles.tableRow} fixed>

        <View style={missingStyles.horaryTableColHeader}>
          <Text style={missingStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={missingStyles.tableColHeader}>
          <Text style={missingStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

      </View>
    );
  }

  createMissingTable = () => {
    return (
      this.props.missing.map(problem => {
        return (
          <View style={missingStyles.tableRow} key={problem._id} wrap={false}>

            <View style={missingStyles.horaryTableCol}>
              <Text style={missingStyles.tableCell}>{this.formatTime(problem)}</Text>
            </View>

            <View style={missingStyles.tableCol}>
              <Text style={missingStyles.tableCell}>{problem.address}</Text>
            </View>

          </View>
        );
      })
    );
  }

  // ----------------- RETRIES -----------------
  createRetriesPages = () => {
    if (this.props.retries.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={retryStyles.page}>

          {this.getPageHeader()}

          <Text style={retryStyles.pageTitle} fixed>{retryPageIndex}. - {Strings.DEVICE_UPDATE_WITH_RETRIES}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.RETRIES_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.RETRIES_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.RETRIES_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.RETRIES_SUGGESTION_4}</Text>
          <Text style={reusableStyles.doubleTabbedText}>i. {Strings.RETRIES_SUGGESTION_5}</Text>
          <Text style={reusableStyles.doubleTabbedText}>ii. {Strings.RETRIES_SUGGESTION_6}</Text>
          <Text style={reusableStyles.doubleTabbedText}>iii. {Strings.RETRIES_SUGGESTION_7}</Text>
          <Text style={reusableStyles.doubleTabbedText}>iv. {Strings.RETRIES_SUGGESTION_8}</Text>
          <Text style={reusableStyles.tabbedText}>c. {Strings.RETRIES_SUGGESTION_10}</Text>
          <Text style={reusableStyles.tabbedText}>d. {Strings.RETRIES_SUGGESTION_13}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={[retryStyles.table, { alignItems: 'center', justifyContent: 'center' }]}>
            {this.createRetriesTableHeader()}
            {this.createRetriesTable()}
          </View>

          {this.getPageFooter("retries")}

        </Page>
      );
    }
  }

  // ----------------- ERROR FRAME -----------------
  createErrorFramePages = () => {
    if (this.props.errorFrame.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={retryStyles.page}>

          {this.getPageHeader()}

          <Text style={retryStyles.pageTitle} fixed>{errorFramaPageIndex}. - {Strings.DEVICE_WITH_UPDATE_ERROR_FRAME}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.ERROR_FRAME_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.ERROR_FRAME_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.ERROR_FRAME_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.ERROR_FRAME_SUGGESTION_4}</Text>
          <Text style={reusableStyles.doubleTabbedText}>i. {Strings.ERROR_FRAME_SUGGESTION_5}</Text>
          <Text style={reusableStyles.doubleTabbedText}>ii. {Strings.ERROR_FRAME_SUGGESTION_6}</Text>
          <Text style={reusableStyles.doubleTabbedText}>iii. {Strings.ERROR_FRAME_SUGGESTION_7}</Text>
          <Text style={reusableStyles.doubleTabbedText}>iv. {Strings.ERROR_FRAME_SUGGESTION_8}</Text>
          <Text style={reusableStyles.tabbedText}>c. {Strings.ERROR_FRAME_SUGGESTION_10}</Text>
          <Text style={reusableStyles.tabbedText}>d. {Strings.ERROR_FRAME_SUGGESTION_13}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={[retryStyles.table, { alignItems: 'center'}]}>
            {this.createErrorFrameTableHeader()}
            {this.createErrorFrameTable()}
          </View>

          {this.getPageFooter("errorFrame")}

        </Page>
      );
    }
  }

  createErrorFrameTableHeader = () => {
    return (
      <View style={retryStyles.tableRow} fixed>

        <View style={retryStyles.horaryTableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.HORARY_DETECTION}</Text>
        </View>

        <View style={retryStyles.horaryTableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.ERROR_FRAMES}</Text>
        </View>

      </View>
    );
  }

  createErrorFrameTable = () => {
    return (
      this.props.errorFrame.map(problem => {

        if (problem._idUpdate !== undefined && problem._idUpdate !== null && problem._idUpdate.includes("Update")) {
          return (
            <>
              <View style={retryStyles.tableRow} key={problem._id} wrap={false}>
                <View style={retryStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
                </View>

                <View style={retryStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{problem.contErrorFrame}</Text>
                </View>

              </View>
              <View style={retryStyles.tableRow} key={problem._id} wrap={false}>
                <View style={retryStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{this.formatTimeUpdate(problem)}</Text>
                </View>

                <View style={retryStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{problem.contErrorFrameUpdate}</Text>
                </View>

              </View>
            </>
          );
        } else {
          return (
            <>
              <View style={retryStyles.tableRow} key={problem._id} wrap={false}>
                <View style={retryStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
                </View>

                <View style={retryStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{problem.contErrorFrame}</Text>
                </View>

              </View>
            </>
          );
        }
      })
    );
  }

  createRetriesTableHeader = () => {
    return (
      <View style={retryStyles.tableRow} fixed>

        <View style={retryStyles.horaryTableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={retryStyles.tableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={retryStyles.tableColHeader}>
          <Text style={retryStyles.tableCellHeader}>{Strings.RETRIES_STRING}</Text>
        </View>

      </View>
    );
  }


  createRetriesTable = () => {
    return (
      this.props.retries.map(problem => {

        if (problem._idUpdate !== undefined && problem._idUpdate !== null && problem._idUpdate.includes("Update")) {
          return (
            <>
              <View style={retryStyles.tableRow} key={problem._id} wrap={false}>
    
                  <View style={retryStyles.horaryTableCol}>
                    <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
                  </View>
    
                  <View style={retryStyles.tableCol}>
                    <Text style={retryStyles.tableCell}>{problem.address}</Text>
                  </View>
    
                  <View style={retryStyles.tableCol}>
                    <Text style={retryStyles.tableCell}>{problem.retries}</Text>
                  </View>
              </View>
              <View style={retryStyles.tableRow} key={problem._id} wrap={false}>
        
                  <View style={retryStyles.horaryTableCol}>
                    <Text style={retryStyles.tableCell}>{this.formatTimeUpdate(problem)}</Text>
                  </View>

                  <View style={retryStyles.tableCol}>
                    <Text style={retryStyles.tableCell}>{problem.address}</Text>
                  </View>

                  <View style={retryStyles.tableCol}>
                    <Text style={retryStyles.tableCell}>{problem.retriesUpdate}</Text>
                  </View>
              </View>
            </>
          );
        }
        else {
          return (
            <View style={retryStyles.tableRow} key={problem._id} wrap={false}>
      
                <View style={retryStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
                </View>
  
                <View style={retryStyles.tableCol}>
                  <Text style={retryStyles.tableCell}>{problem.address}</Text>
                </View>
  
                <View style={retryStyles.tableCol}>
                  <Text style={retryStyles.tableCell}>{problem.retries}</Text>
                </View>
            </View>
          );
        }
      })
    );
  }

  // ----------------- DIAGNOSTICS -----------------
  createDiagnosticsPages = () => {
    if (this.props.diagnostic.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={diagnosticStyles.page}>

          {this.getPageHeader()}

          <Text style={diagnosticStyles.pageTitle} fixed>{diagnosticPageIndex}. - {Strings.DEVICE_UPDATE_WITH_DIAGNOSTIC}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DIAGNOSTIC_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.DIAGNOSTIC_SUGGESTION_2}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={[diagnosticStyles.table, { alignItems: 'center', justifyContent: 'center' }]}>
            {this.createDiagnosticsTableHeader()}
            {this.createDiagnosticsTable()}
          </View>

          {this.getPageFooter("diagnostic")}

        </Page>
      );
    }
  }

  createDiagnosticsTableHeader = () => {
    return (
      <View style={diagnosticStyles.tableRow} fixed>

        <View style={diagnosticStyles.horaryTableColHeader}>
          <Text style={diagnosticStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={diagnosticStyles.tableColHeader}>
          <Text style={diagnosticStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={diagnosticStyles.tableColHeader}>
          <Text style={diagnosticStyles.tableCellHeader}>{Strings.DIAGNOSTICS_STRING}</Text>
        </View>
      </View>
    );
  }

  createDiagnosticsTable = () => {
    return (
      this.props.diagnostic.map(problem => {
        if (problem._idUpdate !== undefined && problem._idUpdate !== null && problem._idUpdate.includes("Update")) {
          return (
            <>
              <View style={diagnosticStyles.tableRow} key={problem._id} wrap={false}>
                <View style={diagnosticStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
                </View>

                <View style={diagnosticStyles.tableCol}>
                  <Text style={diagnosticStyles.tableCell}>{problem.address}</Text>
                </View>

                <View style={diagnosticStyles.tableCol}>
                  {(problem.description.map((description, index) => {
                      return (
                        <Text key={index} style={diagnosticStyles.tableCellDiag}>
                          • {description}
                        </Text>
                      )
                    }))
                  }
                </View>
              </View>
              <View style={diagnosticStyles.tableRow} key={problem._id} wrap={false}>
                <View style={diagnosticStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{this.formatTimeUpdate(problem)}</Text>
                </View>

                <View style={diagnosticStyles.tableCol}>
                  <Text style={diagnosticStyles.tableCell}>{problem.address}</Text>
                </View>

                <View style={diagnosticStyles.tableCol}>
                  {(problem.descriptionUpdate.map((descriptionUpdate, index) => {
                      return (
                        <Text key={index} style={diagnosticStyles.tableCellDiag}>
                          • {descriptionUpdate}
                        </Text>
                      );
                    })) 
                  }
                </View>
              </View>
            </>
          );
        }
        else {
          return (
            <View style={diagnosticStyles.tableRow} key={problem._id} wrap={false}>
              <View style={diagnosticStyles.horaryTableCol}>
                <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
              </View>

              <View style={diagnosticStyles.tableCol}>
                <Text style={diagnosticStyles.tableCell}>{problem.address}</Text>
              </View>

              <View style={diagnosticStyles.tableCol}>
                {(problem.description.map((description, index) => {
                    return (
                      <Text key={index} style={diagnosticStyles.tableCellDiag}>
                        • {description}
                      </Text>
                    )
                  }))
                }
              </View>
            </View>
          );
        }
      })
    );
  }

  // ----------------- FAULTS -----------------
  createFaultsPages = () => {
    if (this.props.fault.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={faultStyles.page}>

          {this.getPageHeader()}

          <Text style={faultStyles.pageTitle} fixed>{faultPageIndex}. - {Strings.DEVICE_UPDATE_WITH_FAULT}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.FAULT_SUGGESTION_1}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.FAULT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>a. {Strings.FAULT_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>b. {Strings.FAULT_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>d. {Strings.FAULT_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>d. {Strings.FAULT_SUGGESTION_6}</Text>

          <Text style={reusableStyles.centeredSecondSubHeaderText}>{Strings.DETAILING}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <View style={[faultStyles.table, { alignItems: 'center', justifyContent: 'center' }]}>
            {this.createFaultsTableHeader()}
            {this.createFaultsTable()}
          </View>

          {this.getPageFooter("fault")}

        </Page>
      );
    }
  }

  createFaultsTableHeader = () => {
    return (
      <View style={faultStyles.tableRow} fixed>

        <View style={faultStyles.horaryTableColHeader}>
          <Text style={faultStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={faultStyles.tableColHeader}>
          <Text style={faultStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={faultStyles.tableColHeader}>
          <Text style={faultStyles.tableCellHeader}>{Strings.FAULTS_STRING}</Text>
        </View>

      </View>
    );
  }

  createFaultsTable = () => {
    return (
      this.props.fault.map(problem => {
        if (problem._idUpdate !== undefined && problem._idUpdate !== null && problem._idUpdate.includes("Update")) {
          return (
            <>
              <View style={faultStyles.tableRow} key={problem._id} wrap={false}>

                <View style={faultStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
                </View>

                <View style={faultStyles.tableCol}>
                  <Text style={faultStyles.tableCell}>{problem.address}</Text>
                </View>

                <View style={faultStyles.tableCol}>
                  <Text style={retryStyles.tableCell}>{problem.faults}</Text>
                </View>

              </View>
              <View style={faultStyles.tableRow} key={problem._id} wrap={false}>

                <View style={faultStyles.horaryTableCol}>
                  <Text style={retryStyles.tableCell}>{this.formatTimeUpdate(problem)}</Text>
                </View>

                <View style={faultStyles.tableCol}>
                  <Text style={faultStyles.tableCell}>{problem.address}</Text>
                </View>

                <View style={faultStyles.tableCol}>
                  <Text style={retryStyles.tableCell}>{problem.faultsUpdate}</Text>
                </View>

              </View>
            </>
          );
        }
        else {
          return (
            <View style={faultStyles.tableRow} key={problem._id} wrap={false}>

              <View style={faultStyles.horaryTableCol}>
                <Text style={retryStyles.tableCell}>{this.formatTime(problem)}</Text>
              </View>

              <View style={faultStyles.tableCol}>
                <Text style={faultStyles.tableCell}>{problem.address}</Text>
              </View>

              <View style={faultStyles.tableCol}>
                <Text style={retryStyles.tableCell}>{problem.faults}</Text>
              </View>

            </View>
          );
        }
      })
    );
  }

  // ----------------- ATTENTION SIGNAL -----------------
  createAttentionSignalPages = () => {
    if (this.props.attentionSignal.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={attentionSignalStyles.page}>

          {this.getPageHeader()}

          <Text style={attentionSignalStyles.pageTitle} fixed>{attentionSignalPageIndex}{Strings.ATTENTION_SIGNAL_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText2}>
            {Strings.ATTENTION_SIGNAL_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.ATTENTION_SIGNAL_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.ATTENTION_SIGNAL_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.ATTENTION_SIGNAL_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.ATTENTION_SIGNAL_SUGGESTION_5}</Text>
          
          <Text style={reusableStyles.lastInfoText}>{Strings.ATTENTION_SIGNAL_SUGGESTION_6}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createAttentionSignalImages()}
          {this.getPageFooter("attentionSignal")}

        </Page>
      );
    }
  }

  createAttentionSignalImages = () => {
    return (
      this.props.attentionSignalImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>{Strings.DEVICE}</Text>
          <View style={reusableStyles.smallSubHeaderLine} />

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.ADDRESS}: </Text>
            {data.address}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.AMPLITUDE}: </Text>
            {(data.amplitude).toFixed(2)} {Strings.VOLTAGE}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- BAD SIGNAL -----------------
  createBadSignalPages = () => {
    if (this.props.badSignal.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={attentionSignalStyles.page}>

          {this.getPageHeader()}

          <Text style={attentionSignalStyles.pageTitle} fixed>{badSignalPageIndex}{Strings.BAD_SIGNAL_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.BAD_SIGNAL_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.BAD_SIGNAL_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.BAD_SIGNAL_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.BAD_SIGNAL_SUGGESTION_4}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.BAD_SIGNAL_SUGGESTION_8}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createBadSignalImages()}
          {this.getPageFooter("badSignal")}

        </Page>
      );
    }
  }

  createBadSignalImages = () => {
    return (
      this.props.badSignalImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>{Strings.DEVICE}</Text>
          <View style={reusableStyles.smallSubHeaderLine} />

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.ADDRESS}: </Text>
            {data.address}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.AMPLITUDE}: </Text>
            {(data.amplitude).toFixed(2)} {Strings.VOLTAGE}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- CAPACITIVE EFFECT -----------------
  createCapacitiveEffectPages = () => {
    if (this.props.capacitiveEffect.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={attentionSignalStyles.page}>

          {this.getPageHeader()}

          <Text style={attentionSignalStyles.pageTitle} fixed>{capacitiveEffectPageIndex}{Strings.CAPACITIVE_EFFECT_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.CAPACITIVE_EFFECT_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.CAPACITIVE_EFFECT_SUGGESTION_1_REPORT}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.CAPACITIVE_EFFECT_SUGGESTION_2}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.CAPACITIVE_EFFECT_SUGGESTION_3}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.lastInfoText}>{Strings.EVIDENCE_DESCRIPTION}</Text>

          {this.createCapacitiveEffectImages()}
          {this.getPageFooter("capacitiveEffect")}

        </Page>
      );
    }
  }

  createCapacitiveEffectImages = () => {
    return (
      this.props.capacitiveEffectImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>{Strings.DEVICE}</Text>
          <View style={reusableStyles.smallSubHeaderLine} />

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.ADDRESS}: </Text>
            {data.address}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.AMPLITUDE}: </Text>
            {(data.amplitude).toFixed(2)} {Strings.VOLTAGE}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- NOISE -----------------
  createNoisePages = () => {
    if (this.props.noise.length > 0) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={attentionSignalStyles.page}>

          {this.getPageHeader()}

          <Text style={attentionSignalStyles.pageTitle} fixed>{noisePageIndex}{Strings.NOISE_PAGE_TITLE}</Text>

          <Text style={reusableStyles.lastInfoText}>
            {Strings.NOISE_PAGE_DESCRIPTION}
          </Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SUGGESTION}</Text>
          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalSpacedText}>{Strings.NOISE_SUGGESTION_2}</Text>

          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_3}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_4}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_5}</Text>
          <Text style={reusableStyles.tabbedText}>• {Strings.NOISE_SUGGESTION_6}</Text>

          <Text style={reusableStyles.normalSpacedText}>{Strings.NOISE_SUGGESTION_7}</Text>

          <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EVIDENCE}</Text>
          <View style={reusableStyles.subHeaderLine} />

          {this.createNoiseImages()}
          {this.getPageFooter("noise")}

        </Page>
      );
    }
  }

  createNoiseImages = () => {
    return (
      this.props.noiseImages.map(data => (
        <View key={data.address} wrap={false}>

          <Text style={reusableStyles.leftSubHeaderText}>{Strings.NOISE}</Text>
          <View style={reusableStyles.smallSubHeaderLine} />

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.AMPLITUDE}: </Text>
            {(data.amplitude).toFixed(2)} {Strings.VOLTAGE}
          </Text>

          <Text style={reusableStyles.normalText}>
            <Text style={reusableStyles.boldText}>{Strings.DETECTED_ON}</Text>
            {this.formatTime2(data.time, data.ntp)}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

        </View >
      ))
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    this.resetSummaryIndexes();
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  leftSubHeaderText: {
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "left",
  },

  centeredSubHeaderText: {
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center",
  },

  centeredSecondSubHeaderText: {
    marginTop: "3vh",
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  smallSubHeaderLine: {
    height: "1px",
    width: "70px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "1vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginTop: "1vh",
    marginBottom: 4,
    fontFamily: "RobotoMedium"
  },

  normalSpacedText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  lastInfoText2: {
    fontSize: 12,
    marginBottom: "4vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  checkBox: {
    width: 12,
    height: 12,
  },

  mainTitleUpperLine: {
    marginTop: "2vh",
    marginBottom: "2vh",
    marginLeft: "180px",
    height: "1px",
    width: "156px",
    backgroundColor: "black",
  },

  mainTitle: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitle2: {
    marginTop: "1vh",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitleBottomLine: {
    marginTop: "2vh",
    marginLeft: "206px",
    height: "1px",
    width: "100px",
    backgroundColor: "black",
  },

  noErrors: {
    //marginTop: "28vh",
    textAlign: "center",
    fontSize: 12,
    //marginBottom: "4vh",
    //fontWeight: "bold",
    fontFamily: "RobotoRegular"
  },

  tabbedText: {
    fontSize: 12,
    marginBottom: "1vh",
    marginLeft: 10,
    fontFamily: "RobotoRegular"
  },

  tabbedText2: {
    fontSize: 12,
    //marginBottom: "1vh",
    marginLeft: 10,
    fontFamily: "RobotoRegular"
  },

  doubleTabbedText: {
    fontSize: 12,
    marginBottom: "1vh",
    marginLeft: 20,
    fontFamily: "RobotoRegular"
  },

  subHeaderInnerLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "1vh"
  },
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const retryStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const diagnosticStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  tableCellDiag: {
    margin: 4,            // Margem para espaçamento
    fontSize: 8,          // Tamanho de fonte ajustado
    fontFamily: "RobotoRegular",  // Fonte personalizada
  },  

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const faultStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const attentionSignalStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 20
  },

  pageTitle: {
    fontSize: 18,
    //marginTop: "2vh",
    marginBottom: "2vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

const oscilloscopeStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  chartImgStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "2vh",
    height: "20vh",
    width: "60vw"
  }
});

const missingStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 115
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "34%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  }
});

export default TsExpertReport;
